import { render, staticRenderFns } from "./ServicesOrders.vue?vue&type=template&id=1e210458&scoped=true"
import script from "./ServicesOrders.vue?vue&type=script&lang=js"
export * from "./ServicesOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e210458",
  null
  
)

export default component.exports